export const giphy = () => (
  <>
    <path
      d="M4.22225 2.77779V5.24334V7.78334V10.3233V12.8622V15.4022V17.9422V20.5556H6.44447V17.9422V15.4022V12.8622V10.3233V7.78334V5.24334V2.77779H4.22225Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#00FF99"
    />
    <path
      d="M17.5556 7.22223V9.81445V12.4811V15.1478V17.8144V20.5556H19.7778V17.8144V15.1478V12.4811V9.81445V7.22223H17.5556Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#9933FF"
    />
    <path
      d="M11.7222 2H9.22225H6.72225H4.22225V4.22222H6.72225H9.22225H11.7222H13.8889V2H11.7222Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FFF35C"
    />
    <path
      opacity="0.4"
      d="M10.8889 4.22222H14.2223L13.1112 2L10.8889 4.22222Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="black"
    />
    <path
      opacity="0.4"
      d="M19.7778 8.66667L17.5556 7.55556V10.8889L19.7778 8.66667Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="black"
    />
    <path
      d="M17.5556 19.7778H15.3334H13.1111H10.8889H8.66669H6.44447H4.22225V22H6.44447H8.66669H10.8889H13.1111H15.3334H17.5556H19.7778V19.7778H17.5556Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#00CCFF"
    />
    <path
      d="M17.5555 6.44444V4.22222H15.3333V2H13.1111V3.81444V6.03667V8.66666H15.3333H17.5555H19.7778V6.44444H17.5555Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FF6666"
    />
  </>
);
